import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { HelpMessage } from 'utils/constants'
import { AsphaltMixDesign } from '../AsphaltMixDesignsContext/types'
import { useAsphaltMixDesignsContext } from '../AsphaltMixDesignsContext'

export function useExpand(): ExpandOptions<AsphaltMixDesign> {
  const { edit, refetch } = useAsphaltMixDesignsContext()
  return {
    render: ({
      globalId,
      customFields,
      percentages,
      active,
      asphaltMaterialSource,
      maxAggregateSize,
    }) => ({
      additionalInfo: [
        {
          type: 'tags',
          label: 'Targets',
          help: HelpMessage.Materials.Asphalt.TargetPercentages,
          tags: percentages.map(
            ({ percentage, target: { name, deleted } }) => ({
              text: `${name} : ${percentage}%`,
              strikethrough: deleted,
            })
          ),
        },
        {
          type: 'default',
          label: 'Max Aggregate Size',
          children: maxAggregateSize,
        },
        {
          type: 'tags',
          label: 'Material Source',
          tags: asphaltMaterialSource
            ? [
                {
                  text:
                    asphaltMaterialSource.source ??
                    asphaltMaterialSource.globalId,
                  strikethrough: asphaltMaterialSource.isDeleted,
                },
              ]
            : [],
        },
      ],
      customFields: {
        customFields,
        alreadyDisabled: false,
        recordInactive: !active,
        listValueOptions: {
          onCheck: async (input) => {
            await edit({
              variables: {
                input: {
                  globalId,
                  customFields: { listInputs: { checkboxes: [input] } },
                },
              },
            })
            refetch()
          },
        },
        booleanValueOptions: {
          onCheck: async (input) => {
            await edit({
              variables: {
                input: { globalId, customFields: { booleanInputs: [input] } },
              },
            })
            refetch()
          },
        },
      },
    }),
  }
}
